import { getPinArrayFromStorage } from '../utils';
export function renderPinnedTaskListHTML() {
  let pinArray = getPinArrayFromStorage();

  if (!pinArray.length) return null;

  return /*html*/ `
    <ul class="list-group list-group-flush pinned-tasks w-50 mb-5 mx-auto">
      ${pinArray.reduce((html, pinnedTask) => {
        const { taskName, taskId } = pinnedTask;
        return (html += /*html*/ `
          <li class="list-group-item">
            <a class="text-white pinned-item-link" href="#${taskId}">${truncateLongTaskName(
          taskName
        )}</a>
            <span 
              data-task-id="${taskId}" 
              data-task-name="${taskName}"
              data-pin-state="true" 
              class="float-right remove-pinned-task"
              style="cursor: pointer;"
            >🗑</span>
          </li>`);
      }, '')}
    </ul>
  `;
}

function truncateLongTaskName(taskName) {
  if (taskName.length < 27) return taskName;

  return `${taskName.slice(0, 27)}...`;
}
